import { render, staticRenderFns } from "./msw-app-nav.vue?vue&type=template&id=f9cbb93e&"
import script from "./msw-app-nav.vue?vue&type=script&lang=ts&"
export * from "./msw-app-nav.vue?vue&type=script&lang=ts&"
import style0 from "./msw-app-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports